import { ButtonGroup } from '@design';
import clsx from 'clsx';
import React, { ReactNode } from 'react';

import styles from './HorizonSelector.module.scss';

export interface HorizonSelectorProps {
  horizonLabels: ReactNode[];
  activeHorizonIndex: number;
  onClick: (index: number) => void;
  className?: string;
}

export const HorizonSelector = ({
  horizonLabels,
  activeHorizonIndex,
  onClick,
  className,
}: HorizonSelectorProps) => {
  return (
    <div
      className={clsx(styles.horizonSelectorRoot, className)}
      data-testid="horizon-selector"
    >
      <ButtonGroup
        className={styles.styledButtonGroup}
        labels={horizonLabels}
        onClick={onClick}
        activeIndex={activeHorizonIndex}
      />
    </div>
  );
};
